import { GetFileInsuranceQueryParamsType } from '@/modules/adjusterReportModules/adjusterReport/queries/getFileInsurance/getFileInsuranceQuery.type';
import { getFileInsuranceFunction } from '@/modules/adjusterReportModules/adjusterReport/queries/getFileInsurance/getFileInsuranceQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getFileInsuranceQueryOptions = (
  params: GetFileInsuranceQueryParamsType,
) => {
  return queryOptions({
    queryKey: ['file_insurance', params],
    queryFn: () => getFileInsuranceFunction(params),
    enabled: true,
  });
};
